import { User } from '../../../types';

export enum QuestionnaireType {
  MANUAL = 'MANUAL',
  TEMPLATE_BASED = 'TEMPLATE_BASED',
  PROFILE_BASED_AI = 'PROFILE_BASED_AI',
  RESULT_BASED_AI = 'RESULT_BASED_AI',
}

export class SurveyChoice {
  value: string | number;
  text: string;
}

export class SurveyMatrixColumn {
  name: string;
  title: string;
  cellType: string;
  isRequired: boolean;
  choices?: SurveyChoice[];
  visibleIf?: string;
}

export class SurveyRow {
  value: string;
  text: string;
}

export class SurveyElement {
  type: string;
  name: string;
  title: string;
  isRequired?: boolean;
  maxLength?: number;
  inputType?: string;
  startWithNewLine?: boolean;
  visible?: boolean;
  visibleIf?: string;
  elements?: SurveyElement[];
  choices?: SurveyChoice[] | string[];
  columns?: SurveyMatrixColumn[];
  rows?: (string | SurveyRow)[];
  templateElements?: SurveyElement[];
  colCount?: number;
  description?: string;
  addRowText?: string;
  metadata?: any;
}

export class SurveyPage {
  name: string;
  elements: SurveyElement[];
  title: string;
  questionTitleLocation?: string;
}

export class SurveyJSON {
  title: string;
  description?: string;
  pages: SurveyPage[];
  logoPosition?: string;
  questionErrorLocation?: string;
  showQuestionNumbers?: string;
  showProgressBar?: string;
}

export class SurveyAnswer {
  name: string;
  value: string | number | boolean | (string | number)[];
}

export class SurveyAnswers {
  answers: SurveyAnswer[];
}

export class QuestionnaireResponse {
  id: number;
  createdAt: Date;
  userId: number;
  answers: SurveyAnswers;
  questionnaireId: number;
  questionnaire: Questionnaire;
}

export class Questionnaire {
  id: number;
  userId: number;
  providerId: number;
  type: QuestionnaireType;
  createdAt: string;
  algocyteGptOutput?: CreateSurveyResponseDto;
  resultSetId?: number;
  response?: QuestionnaireResponse;
  questionnaireSchema: SurveyJSON;
  templateId?: number;
  user?: User;
  provider?: User;
}

export class QuestionnaireTemplate {
  id: number;
  providerId: number;
  createdAt: string;
  updatedAt: string;
  questionnaireSchema: SurveyJSON;
}

export class PromptResponse {
  prompt: string;
}

export class CreatePromptInputDto {
  type: QuestionnaireType;
  userId: number;
  resultSetId?: number;
}

export class CreateSurveyInputDto {
  message: string;
  userId: number;
  type: QuestionnaireType;
}

export class SurveyQuestion {
  question: string;
  hypothesis: string;
  prognosis: string;
  test: string;
  therapy: string;
  score: number;
  ICDcode: string;
}

export class CreateSurveyResponseDto {
  summary: string;
  followUpQuestions: SurveyQuestion[];
  holistic: string;
  additionalNotes: string;
}

export class CreateResponseDto {
  questionnaireId: number;
  answers: SurveyAnswers;
}

export class CreateQuestionnaireDto {
  userId: number;
  type: QuestionnaireType;
  questionnaireSchema: SurveyJSON;
  resultSetId?: number;
  algocyteGptOutput?: CreateSurveyResponseDto;
  templateId?: number;
}

export class CreateQuestionnaireTemplateDto {
  questionnaireSchema: SurveyJSON;
}
